import { api } from "utils/hostname";
import url from "url/index";
import { CurrencyResponseType, CurrencyType } from "types/Currency";
import { setServiceError } from "stores/settings";

export const fetchCurrencies = async (): Promise<CurrencyType[]> => {
  try {
    const response = await api().get<CurrencyResponseType>(
      url.config.api.catalogs.currencies,
      {
        headers: {
          "f-v": import.meta.env.VITE_APP_VERSION_APP,
        },
      },
    );
    if (response.data.statusCode >= 500) {
      setServiceError(true);
      throw new Error("Server error");
    }
    return response.data.currencies.map((cur) => ({
      ...cur,
      id: cur.id,
      name: cur.isoCode,
    }));
  } catch (error) {
    throw new Error("Fetch currencies error");
  }
};
